module.exports = __webpack_public_path__ + "img/181.service.443fe9af.svg";